export default "<!-- to load multiple pages -->\r\n<navigation></navigation>\r\n<router-outlet></router-outlet>\r\n\r\n\r\n  \r\n\r\n";